import Vue from 'vue';

import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';

import { store } from '@/store';

import { scrollBehavior } from '@cnamts/vue-dot/src/helpers/scrollBehavior';
import { navigationRedirect } from './navigationRedirect';
import { routes } from './routes';
import AuthService from '@/services/auth';

Vue.use(VueRouter);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

const router = new VueRouter({
  mode: 'history', // Use the History API, and remove the hash from the URL
  routes,
  scrollBehavior
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const loggedIn = AuthService.isLoggedIn();
  const userInfo = AuthService.getUserInfo();
  const cguAccepted = userInfo ? userInfo.cguAccepted : false;
  const hasEmail = userInfo
    ? userInfo.email && userInfo.email.length > 0
    : false;

  window.document.title = to.meta && to.meta.titre ? to.meta.titre : '';

  store.dispatch('notification/clear');

  // Vérifie si la destination est identique à l'emplacement actuel
  if (to.path !== from.path) {
    // On permet la déconnexion dans tous les cas
    if (to.path === '/logout') {
      return next();
    }

    // Redirige vers la page d'accueil si l'utilisateur est déjà authentifié
    if (loggedIn && to.path === '/login') {
      next('/dpa/historique');
      // Redirige vers la page de login si la page nécessite une authentification
    } else if (requiresAuth && !loggedIn) {
      next('/login');
      // Déconnexion de l'utilisateur
    } else if (to.path === '/' && loggedIn) {
      next('/');
      // Continue la navigation
    } else {
      navigationRedirect(to, from, next);
    }

    if (loggedIn) {
      if (!hasEmail) {
        return next('/create-email');
      }
      if (!cguAccepted && to.path !== '/cgu') {
        return next('/cgu');
      }
    }
    // Gestion page accueil si non connecté
  } else if (to.path === '/' && !loggedIn) {
    // Vérifie la présence du jeton psben
    const jetonPsben = to.query.psben;

    if (jetonPsben) {
      next({ path: '/loginam', query: { jetonPsben } });
    } else {
      next('/login');
    }
  } else {
    // Continue la navigation si l'utilisateur est toujours connecté
    if (loggedIn) {
      navigationRedirect(to, from, next);
    } else {
      // Arrête la navigation si l'utilisateur est déconnecté
      next(false);
    }
  }
});
export { router };
